import { map } from "../breakpoint";
export function getSpacingFromTheme(key, theme) {
  var value = theme && theme.spacing && theme.spacing[key];
  if (typeof value === "undefined") {
    console.error("A spacing named \"".concat(key, "\" does not exist.")); // eslint-disable-line no-console
    return "0";
  }
  return value;
}
export function _m(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _mx(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin-inline: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _my(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin-block: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _mt(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin-block-start: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _mr(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin-inline-end: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _mb(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        margin-block-end: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _ml(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n      margin-inline-start: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _p(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _px(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-inline: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _py(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-block: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _pt(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-block-start: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _pr(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-inline-end: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _pb(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-block-end: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}
export function _pl(values, theme) {
  return map(values, function (key) {
    if (typeof key === "string" || typeof key === "number") {
      return "\n        padding-inline-start: ".concat(getSpacingFromTheme(key, theme), ";\n      ");
    }
    return "";
  });
}